var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConsultarCliente(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8033 7.90167C15.8033 9.44688 15.3644 10.9043 14.5917 12.1159L20 17.5593L17.5593 20L12.0808 14.6093C10.8692 15.3644 9.42932 15.8033 7.90167 15.8033C3.51185 15.8033 0 12.2915 0 7.90167C0 3.51185 3.51185 0 7.90167 0C12.2915 0 15.8033 3.51185 15.8033 7.90167ZM3.58974 7.94872C3.58974 10.3549 5.54256 12.3077 7.94872 12.3077C10.3549 12.3077 12.3077 10.3549 12.3077 7.94872C12.3077 5.54256 10.3549 3.58974 7.94872 3.58974C5.54256 3.58974 3.58974 5.54256 3.58974 7.94872Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultarCliente);
export default __webpack_public_path__ + "static/media/consultar-cliente.c7fcee3358571f7c2ed3d6131f4cbaa1.svg";
export { ForwardRef as ReactComponent };